import styled, { css } from 'styled-components';
import { NeuCard, NeuButton } from '@neutron/react';

interface DropdownProps {
  showPopover: boolean;
}

interface CSSProps {
  autoWidth?: boolean | undefined;
  centered?: boolean | undefined;
}

export const ModalContainer = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 28em;
  background: #f6f6f6 !important;
  z-index: 10;
  margin-inline-end: 0;
  margin-top: 0;
`;

export const CardHeader = styled(NeuCard)`
  display: flex;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  height: 56px;
  width: 100%;
  --background: white;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow: hidden;
`;

export const InputHeading = styled.div<CSSProps>`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 12px;
  ${({ autoWidth }) =>
    autoWidth &&
    css`
      width: auto;
    `}
`;

export const ModalFooter = styled(NeuCard)<{ right?: boolean }>`
  background: white !important;
  bottom: 0;
  height: 56px !important;
  border-top: 1px solid #b0b0b0;
  ${props =>
    !props.right &&
    css`
      display: flex;
      align-items: center;
      justify-content: end;
    `};
`;

export const ListContainer = styled.div`
  height: calc(100% - 117px);
  margin-top: 15px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(224, 224, 224);
    border-radius: 10px;
  }
  overflow-x: hidden;
  scroll-behavior: smooth;
`;

export const ListRow = styled.div`
  display: flex;
  padding-top: 10px;
  column-gap: 10px;
  border-top: 1px solid #b0b0b0;
`;

export const ListHeader = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
`;

export const EmployeeNameInTable = styled.p`
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #093865;
`;

export const TextInTable = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #4b4b4b;
`;

export const RemoveButton = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0px;
  padding-bottom: 10px;
  text-align: left;
  color: #ce3637;
  :hover {
    cursor: pointer;
  }
`;

// TODO: Not currently being used
export const AddSelectedEmployeeButton = styled.button`
  width: 368px;
  height: 44px;
  gap: spacer-3;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #005a8d;
  color: #ffffff;
  border-radius: 15px;
  font-size: 0.75rem;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 20px;
  margin-left: 20px;
  padding-top: 3px;
  padding-right: spacer-4;
  padding-bottom: 3px;
  padding-left: spacer-3;
  text-align: center;
  align-items: center;
`;
